<template>
    <div class="card no-shadow m-l-12 reviews-section">
        <div class="card-content">
            <div class="columns is-paddingless is-marginless summary-info">
                <div class="column is-paddingless" >
                    <div>
                        <div class="card-content">
                            <div class="content " v-if="!fetching_reviews" id="reviewInfo">
                                <div class="columns is-paddingless">
                                    <div class="column is-paddingless has-text-weight-bold is-size-7 has-text-grey is-narrow">Reviews remaining</div>
                                    <div class="column is-paddingless is-marginless is-size-7 has-text-grey is-2 is-italic">{{ package_remaning }}</div>
                                    <div class="column is-paddingless has-text-weight-bold is-size-7 has-text-grey is-narrow">Active reviews</div>
                                    <div class="column is-paddingless is-marginless is-size-7 has-text-grey is-3 is-italic">{{ reviewsInSubs }} in current subscription</div>
                                    <div class="column is-paddingless has-text-weight-bold is-size-7 has-text-grey is-narrow">Replies sent</div>
                                    <div class="column is-paddingless is-marginless is-size-7 has-text-grey is-3 is-italic">{{ reviewsRepliesInSubs }} in current subscription</div>
                                </div>
                                <div class="columns is-paddingless">
                                    <div class="column is-paddingless has-text-weight-bold is-size-7 is-narrow is-invisible-tablet is-hidden-mobile">Reviews remaining</div>
                                    <div class="column is-paddingless is-marginless is-2"></div>
                                    <div class="column is-paddingless has-text-weight-bold is-size-7 is-narrow is-invisible-tablet is-hidden-mobile">Active reviews</div>
                                    <div class="column is-paddingless is-marginless is-size-7 has-text-grey is-3 is-italic">{{ reviewsIn12Months }} in the last 12 months</div>
                                </div>
                                <div class="columns is-paddingless">
                                    <div class="column is-paddingless has-text-weight-bold is-size-7 is-narrow is-invisible-tablet is-hidden-mobile">Reviews remaining</div>
                                    <div class="column is-paddingless is-marginless is-2"></div>
                                    <div class="column is-paddingless has-text-weight-bold is-size-7 is-narrow is-invisible-tablet is-hidden-mobile">Active reviews</div>
                                    <div class="column is-paddingless is-marginless is-size-7 has-text-grey is-3 is-italic">{{ reviewsInLastYear }} last year</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Filter Begins -->
            <div class="columns margin-0 filter-section">
              <!-- Search Filter Begins -->
              <div class="column is-3 padding-left-0 search-filter">
                <Search
                  class="is-paddingless is-marginless"
                  data-track="Portal-Admin - Search In Admin Businesses Reviews Lists"
                  desktopCss="is-12-tablet is-11-desktop"
                  placeholder="Search by Email or IP Address"
                  :addMarginLeft=false
                  v-on:search="handleSearch($event)"
                />
              </div> <!-- Search Filter Ends -->
              <!-- Status Filter Begins -->
              <div class="column is-1 status-filter">
                <multiple-selection-drop-down
                  ref="status"
                  class="is-paddingless is-marginless"
                  data-track="Portal-Admin - Business Reviews Lists Status Dropdown change"
                  btnMinWidth="button-width-200px"
                  dropdownName="payment_method"
                  placeHolder="Select Status"
                  :items.sync="status"
                  :checkedItems="filters.checkedItems"
                  @checkbox-values="setReviewStatus"
                />
              </div> <!-- Status Filter Ends -->
              <!-- Date Filter Begins -->
              <div class="column is-4 padding-top-0 padding-right-0 date-filter">
                <date-select-filter
                  class="custom-dropdown"
                  :filter_items="filters.dateFilter.props"
                  :styleProp="filters.dateFilter.styleProp"
                  :reviews_start_date="filters.dateFilter.reviews_start_date"
                  @onDateChange="handleDateChange"
                  data-track="Portal-Admin - Business Reviews Lists Date Change"
                />
              </div> <!-- Date Filter Ends -->
              <div class="column is-narrow padding-left-0">
                <button data-track="Portal-Admin - Delete Admin Businesses Review" class="button is-button-dark-blue-outline is-uppercase" :class="[{'is-loading': loaders.isDeleting}]" :disabled="!reviews.length || loaders.isDeleting" @click="actionHandler('delete')">
                  {{ !loaders.isDeleting ? 'Delete' : '' }}
                </button>
              </div>
              <div class="column is-narrow padding-left-0">
                <a data-track="Portal-Admin - Export Admin Businesses Reviews Lists" class="button is-button-dark-blue-outline is-uppercase" :class="[{'is-loading': loaders.isExporting}]" :disabled="!reviews.length || loaders.isExporting" @click="handleReviewExport">
                  {{ !loaders.isExporting ? 'Export' : '' }}
                </a>
              </div>
              <div class="column is-narrow padding-left-0">
                <button data-track="Portal-Admin - Republish Admin Businesses Reviews Lists" class="button is-button-dark-blue is-uppercase" :class="[{'is-loading': loaders.isRepublishing}]" :disabled="!reviews.length || loaders.isRepublishing" @click="actionHandler('republish')">
                  {{ !loaders.isRepublishing ? 'Re - publish' : '' }}
                </button>
              </div>
            </div>
            <!-- Filters Ends -->
            <div class="columns is-marginless sum-up">
              <div class="column is-narrow padding-left-0" v-if="!fetching_reviews" v-resultsCount="dataSet.total"></div>
              <div class="column">{{reviews.length}} Selected</div>
            </div>
            <div class="content">
                <div class="column is-paddingless">
                    <table class="table is-fullwidth transparent-table">
                        <thead>
                            <tr class="cat-list">
                                <td class="pad35-desktop is-desktop is-size-7 has-text-weight-bold has-text-grey is-narrow">
                                  <label class="checkbox is-size-6 label-filters">
                                    <input
                                      data-track="Portal-Admin - Check Admin Businesses Reviews List"
                                      type="checkbox"
                                      class=""
                                      :checked="reviewsCollection && (reviewsCollection.reviewIds.length === reviews.length)"
                                      @change="checkAllReviews"
                                    >
                                    <span class="checkmark"></span>
                                  </label>
                                </td>
                                <td class="pad35-desktop is-desktop is-size-7 has-text-weight-bold has-text-grey date-col">Date</td>
                                <td class="pad90-desktop is-size-7 has-text-weight-bold has-text-grey reviewer-col">Reviewer</td>
                                <td class="is-three-fifths review-title is-size-7 has-text-weight-bold has-text-grey is-hidden-mobile">Review title</td>
                                <td class="is-size-7-mobile is-size-7 has-text-weight-bold has-text-grey is-narrow is-hidden-touch">IP Address</td>
                                <td class="is-size-7-mobile is-size-7 has-text-weight-bold has-text-grey is-narrow is-hidden-touch">Source</td>
                                <td class="is-size-7-mobile is-size-7 has-text-weight-bold has-text-grey is-narrow">Reply</td>
                                <td class="is-size-7-mobile is-size-7 has-text-weight-bold has-text-grey is-narrow">Status</td>
                                <td class="is-size-7-mobile is-size-7 has-text-weight-bold has-text-grey is-narrow">NPS</td>
                            </tr>
                        </thead>
                        <tbody>
                            <business-review-item v-if="items.length > 0"
                              v-for="(review, index) in items"
                              :key="review.id"
                              :showDetailsButton="false"
                              :setRatingContWidth="false"
                              :checkReportStatus="true"
                              :addClickEvent="true"
                              :businessSlugFromProp="getBusinessSlug"
                              :orgSlug="getBusinessSlug"
                              onPage="BizReviewsListing"
                              :data="review"
                              :reviewIndex="index"
                              :reviews="reviews"
                            >
                            </business-review-item>
                        </tbody>
                    </table>
                    <table v-if="!fetching_reviews && items.length === 0"
                           class="table is-fullwidth has-vertically-aligned-content">
                        <tbody>
                        <tr>
                            <td class="is-narrow">
                                <p class="is-size-7 has-text-weight-bold has-text-grey has-text-centered">No reviews found for business.</p>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <!-- paginator -->
            <paginator :dataSet="dataSet" @changed="getReviews" ref="monk"></paginator>
        </div>
      <!-- Confirmation Modal -->
      <ModalPopup
        primaryBtnText="Cancel"
        :title="confirmationModal.title"
        :body="confirmationModal.body"
        :secondaryBtnText="confirmationModal.secondaryBtnText"
        :onBlur="stayOnPage"
        :primaryBtnAction="stayOnPage"
        :secondaryBtnAction="loaders.isDeleting ? handleMultiDelete : handleMultiRepublish"
      />
      <!-- Confirmation Modal -->
      <!-- Hidden form for export reviews -->
      <form class="is-invisible" name="downloadReviewsExport" v-if="formData.length > 0" method="post" :action="formAction" target="_self">
        <input v-for="param in formData" :name="param.name" :value="param.value" type="hidden" />
        <input type="submit" class="button is-button-blue-outline is-fullwidth" value="Click here to continue" />
      </form>
      <!-- Hidden form for export reviews -->
    </div>
</template>
<script>
  /* eslint-disable indent,no-new,no-undef, valid-jsdoc */
  import misc from '@/mixins/misc.js'
  import axios from 'axios'
  import moment from 'moment'
  import { mapState, mapActions } from 'vuex'
  import { SHOW_MODAL } from '@/store/action.types'
  import BusinessReviewItem from '../reviews/BusinessReviewItem.vue'
  import { Search, Paginator, ModalPopup, DateSelectFilter, MultipleSelectionDropDown } from '@/components'

  export default {
    components: {
      Search,
      Paginator,
      ModalPopup,
      DateSelectFilter,
      BusinessReviewItem,
      MultipleSelectionDropDown
    },
    mounted () {
      localStorage.removeItem('sweep')
    },
    mixins: [misc],
    props: {
      businessName: {
        type: String
      },
      subscription: {
        type: String
      },
      reviewsRemaining: {
        type: Number
      }
    },
    data () {
      return {
        formData: [],
        formAction: '',
        is_loading: true,
        fetching_reviews: false,
        items: [],
        dataSet: {},
        reviews: [],
        reviewsCollection: null,
        bizUserDetails: [],
        reviewsInSubs: 0,
        reviewsIn12Months: 0,
        reviewsInLastYear: 0,
        reviewsRepliesInSubs: 0,
        status: [
          {
            name: 'Active',
            value: '1'
          },
          {
            name: 'Deleted',
            value: '2'
          }
        ],
        loaders: {isDeleting: false, isExporting: false, isRepublishing: false},
        confirmationModal: {title: '', body: '', secondaryBtnText: '', secondaryBtnAction: null},
        filters: {
          checkedItems: [],
          searchFilter: '',
          dateFilter: {
            label: 'All time',
            endDate: null,
            startDate: null,
            styleProp: {},
            reviews_start_date: '',
            props: [
              {
                name: 'date',
                label: 'Date',
                showApplyBtn: true,
                default: { type: 'months', value: 6, selected: 'All time' }, // moment.js placeholder in type
                disabled: [],
                elements: [
                  'Last 7 days',
                  'Previous month',
                  'Last 6 months',
                  'Last 12 months',
                  'All time',
                  'Custom'
                ]
              }
            ]
          }
        }
      }
    },
    computed: {
      ...mapState({
        modal: state => state.app.modal
      }),
      getBusinessSlug () {
        return this.$router.currentRoute.params.slug
      },
      package_remaning () {
        let text = ''
        if (!this.subscription) {
            text = '0 - Unclaimed'
        } else if (this.subscription === 'Free') {
            text = '0 - Free package'
        } else if (this.subscription === 'Enterprise') {
            text = 'Unlimited'
        } else if (this.subscription === 'P4 Annual') {
            text = 'Unlimited'
        } else {
          text = `${this.reviewsRemaining} - ${this.subscription} package`
        }
        return text
      },
      /**
       * Creating a payload for HTTP request
       * @return {object}
       */
      payload () {
        return {
          endDate: this.filters.dateFilter.startDate,
          startDate: this.filters.dateFilter.endDate,
          search: this.filters.searchFilter,
          businessSlug: this.getBusinessSlug,
          includeDeletedReviews: true
        }
      },
      /**
       * Get review export link
       * @return {string}
       */
      reviewExport () {
        let reviewString = ''
        if (this.reviews) {
          this.reviews.forEach((review, index) => {
            reviewString += `&reviews[${index}]=${review}`
          })
        }
        return process.env.API_URL + `/${this.getBusinessSlug}/reports/export-reviews?includeDeletedReviews=true&end_date=${this.payload.endDate}&start_date=${this.payload.startDate}&search=${this.payload.search}${reviewString}`
      }
    },
    created () {
      this.getReviewsCountStats()

      window.events.$on('inputFromReview', (reviewData) => {
        this.handleCheckboxChange(reviewData)
      })
    },
    methods: {
      ...mapActions({
        'showModal': `app/${SHOW_MODAL}`
      }),
      authorDisplayName (name) {
        return name.replace(' ', '&nbsp;')
      },
      formatDate (dateString, dateFormat) {
        return moment(dateString).format(dateFormat)
      },
      /**
       * Get basic information about business
       * @return {Promise}
       */
      getBusinessInfo () {
        return new Promise((resolve) => {
          axios.get(`business/${this.getBusinessSlug}/info`)
            .then(({data}) => {
              this.business = data.data
              this.filters.dateFilter.reviews_start_date = data.data.review.firstReview ? moment(data.data.review.firstReview.created_at).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')
              resolve(data.data)
            })
            .catch((error) => {
              flash(`${error.message}`, 'is-danger')
            })
        })
      },
      /**
       * Makes an api call to get reviews for org
       * @param {number | null} page to return data from
       * @returns {void}
       */
      getReviews (page) {
        this.fetching_reviews = true
        axios.get(this.url(page))
        .then((reviews) => {
          this.reviewsCollection = reviews.data
          this.fetching_reviews = false
          this.refresh(reviews, 'reviews')
          window.document.title = `Business Portal | Hellopeter - ${this.businessName} (Reviews)`
          this.$gtm.trackEvent({
            event: 'pageLoad',
            virtualPageUrl: this.$router.currentRoute.path,
            virtualPageTitle: window.document.title
          })
          window.scrollTo(0, 0)
        })
        .catch(() => {
          parent.fetching_reviews = false
        })
      },
      url (page) {
        if (!page) {
          let query = location.search.match(/page=(\d+)/)

          page = query ? query[1] : 1
        }
        let statusString = ''
        if (this.filters.checkedItems) {
          this.filters.checkedItems.forEach((status, index) => {
            statusString += `&reviewStatus[${index}]=${status}`
          })
        }
        return `/${this.getBusinessSlug}/reviews?page=${page}&isHpAdminMenu=true&per_page=20&end_date=${this.payload.endDate}&start_date=${this.payload.startDate}&search=${this.payload.search}&businessSlug=${this.payload.businessSlug}${statusString}`
      },
      /**
       * Makes an api call to get reviews count statistics for org
       * @returns {void}
       */
      getReviewsCountStats () {
        axios.get(`/${this.getBusinessSlug}/reviews-count-stats`)
        .then((stats) => {
          this.reviewsInSubs = stats.data.reviewsInSubs
          this.reviewsIn12Months = stats.data.reviewsIn12Months
          this.reviewsInLastYear = stats.data.reviewsInLastYear
          this.reviewsRepliesInSubs = stats.data.reviewsRepliesInSubs
        })
      },
      /**
       * Check mark all the reviews
       * @param {object} e
       * @returns {void}
       */
      checkAllReviews (e) {
        if (e.target.checked) {
          this.reviewsCollection.reviewIds.forEach((obj) => {
            if (!this.reviews.includes(parseInt(obj))) {
              this.reviews.push(parseInt(obj))
            }
          })
        } else {
          this.reviews = []
        }
      },
      /**
       * Handle checkbox change
       * @param {object} data
       * @returns {void}
       */
      handleCheckboxChange (data) {
        if (data.checked) {
          this.reviews.push(parseInt(data.value))
        } else {
          this.$delete(this.reviews, this.reviews.indexOf(parseInt(data.value)))
        }
      },
      /**
       * Search keyword/term to search for
       * @param {string} search search term/keyword
       * @returns {void}
       */
      handleSearch (search) {
        this.filters.searchFilter = Object.keys(search).length ? search : ''
        this.getReviews(null)
      },
      /**
       * Handle Date Dropdown Filter
       * @param {object} dateFilter Date data to sort on
       * @return {void}
       */
      handleDateChange (dateFilter) {
        this.reviews = []
        Object.assign(this.filters.dateFilter, dateFilter)
        if (dateFilter.label === 'all_time') {
          this.getBusinessInfo()
          .then(() => {
            this.filters.dateFilter.startDate = this.filters.dateFilter.reviews_start_date
            this.filters.dateFilter.endDate = moment().format('YYYY-MM-DD')
            this.getReviews(null)
          })
        } else {
          this.getReviews(null)
        }
      },
      /**
       * Handle modal as per action
       * @param {object} action
       * @return {void}
       */
      actionHandler (action) {
        this.showModal()
        if (action === 'delete') {
          this.loaders.isDeleting = true
          Object.assign(this.confirmationModal, {
            title: 'DELETE REVIEWS?',
            body: `You're about to delete these reviews. If you proceed they will be removed from the Businesses public account.`,
            secondaryBtnText: 'Delete Reviews'
          })
        } else if (action === 'republish') {
          this.loaders.isRepublishing = true
          Object.assign(this.confirmationModal, {
            title: 'RE-PUBLISH REVIEWS?',
            body: `You're about to re-publish these reviews. If you proceed they will be visible on the Businesses public account.`,
            secondaryBtnText: 'Re-publish Reviews'
          })
        }
      },
      /**
       * Handle Multiple Review Deletion
       * @return {void}
       */
      handleMultiDelete () {
        this.showModal(false)
        axios.post(`${this.getBusinessSlug}/reviews/delete`, {
          reviews: this.reviews
        })
        .then(({data}) => {
          this.reviews = []
          this.stayOnPage()
          this.getReviews(null)
          flash(`${data.message}`, 'is-success')
          window.location.reload()
          dataLayer.push({
            'userMessage': {
              'messageType': 'success',
              'messageName': 'Multiple reviews delete successfully',
              'displayedMessage': 'Multiple reviews delete successfully'
            }
          })
        })
        .catch((error) => {
          console.log(error)
          this.stayOnPage()
          flash(`${error.message}`, 'is-danger')
        })
      },
      /**
       * Handle Multiple Review Deletion
       * @return {void}
       */
      handleMultiRepublish () {
        this.showModal(false)
        axios.post(`${this.getBusinessSlug}/reviews/republish`, {
          reviews: this.reviews
        })
        .then(({data}) => {
          this.reviews = []
          this.stayOnPage()
          this.getReviews(null)
          flash(`${data.message}`, 'is-success')
          window.location.reload()
          dataLayer.push({
            'userMessage': {
              'messageType': 'success',
              'messageName': 'Multiple reviews republished successfully',
              'displayedMessage': 'Multiple reviews republished successfully'
            }
          })
        })
        .catch((error) => {
          this.stayOnPage()
          console.log(error)
          flash(`${error.message}`, 'is-danger')
        })
      },
      /**
       * Handle Review Export
       * @return {void}
       */
      handleReviewExport () {
        this.loaders.isExporting = true
        if (this.reviews.length > 0) {
          this.formAction = `${process.env.API_URL}/${this.getBusinessSlug}/reports/export-admin-reviews`
          this.formData = []
          this.formData.push({
            name: 'reviews',
            value: this.reviews.join(',')
          })
          setTimeout(() => {
            document.forms['downloadReviewsExport'].submit()
          }, 500)
        }
        this.loaders.isExporting = false
      },
      /**
       * Sets Status method to filter by
       * @param {object} checkedValues
       * @returns {void}
       */
      setReviewStatus (checkedValues) {
        this.reviews = []
        this.filters.checkedItems = checkedValues
        this.getReviews(null)
      },
      /**
       * Stay on the page and close modal when clicked on stay on this page
       * @return {void}
       */
      stayOnPage () {
        this.loaders.isDeleting = this.loaders.isRepublishing = false
        this.showModal(false)
      }
    }
  }
</script>

<style scoped>
    .button[disabled] {
      color: #cdcbcb !important;
      border: 1px solid #cdcbcb !important;
      background-color: #ffffff !important;
    }
    .table td, .table th {
        border: none;
        padding: 0.7rem 0.75em !important;
    }
    .table > tbody > tr {
        background-color: #f5f5f5 !important;
        margin-bottom: 10px;
    }
    .table > tbody > td {
        margin-bottom: 20px;
    }
    .date-col {
        width: 10%;
    }
    .reviewer-col {
        width: 28% !important;
    }
    .card-content {
        padding: 0rem;
    }
    .card-content .card-content {
        padding-bottom: 1.5rem;
    }
    #reviewInfo .column:nth-child(odd) {
       padding-right: 10px !important;
    }

    /* Create a custom checkbox Begins */
    .label-filters input[type="checkbox"] {
      visibility: hidden;
    }
    .checkmark {
      position: absolute;
      top: 4px;
      left: 0;
      height: 10px;
      width: 10px;
      background-color: #fff;
      border: solid 1px #707070;
    }
    /* On mouse-over, add a grey background color */
    .label-filters:hover input ~ .checkmark {
      background-color: #fff;
    }
    /* When the checkbox is checked, add a blue background */
    .label-filters input:checked ~ .checkmark {
      border: none;
      background-color: #30aae1;
    }
    /* Create the checkmark/indicator (hidden when not checked) */
    .checkmark:after {
      content: "";
      position: absolute;
      display: none;
    }
    /* Show the checkmark when checked */
    .label-filters input:checked ~ .checkmark:after {
      display: block;
    }
    /* Style the checkmark/indicator */
    .label-filters .checkmark:after {
      left: 3px;
      top: 0px;
      width: 5px;
      height: 8px;
      border: solid white;
      border-width: 0 2px 2px 0;
      -webkit-transform: rotate(45deg);
      transform: rotate(45deg);
    }
    /* Create a custom checkbox Ends */

    @media screen and (max-width: 767px) {
        #reviewInfo > .columns {
            margin-bottom: 0;
        }

        #reviewInfo > .columns:first-child > .column:nth-child(3) {
            margin-top: calc(1.5rem - 0.75rem);
        }
    }
</style>
<style lang="scss" scoped>
  $text-color: #58595b;
  $link-color: #30aae1;
  $blue-text-color: #1261a0;

  .reviews-section {
    .sum-up {
      color: $text-color;
      font-size: 12px;

      &>>> .has-text-grey {
        color: $text-color !important;
      }
    }
    .summary-info {
      border-bottom: solid 1px rgba(88, 89, 91, 0.2);
    }
    .filter-section {
      .button {
        width: 105px;
        height: 35px;

        &:disabled {
          color: #cdcbcb !important;
          border: 1px solid #cdcbcb !important;
          background-color: #ffffff !important;
        }
      }
      &>>>.columns {
        .is-paddingless {
          /*height: 35px;*/
        }
      }
      &>>>.button-dropdown {
        height: 37px;
        min-height: 35px !important;
      }
      &>>>.border-bottom-dbdbdb {
        padding: 12px 12px !important;

        .is-paddingless {
          height: auto;
        }
      }
      .search-filter {
        @media screen and (min-width: 767px) and (max-width: 1400px) {
          width: 21%;
        }
      }
      .status-filter {
        &>>>.button-width-200px {
          min-width: 165px !important;
        }
        &>>>.dropdown-menu {
          min-width: 165px !important;
        }
        @media screen and (max-width: 1500px) {
          margin-right: 45px;
        }
        @media screen and (min-width: 767px) and (max-width: 1400px) {
          margin-left: 0.5%;
          margin-right: 4.5%;

          &>>>.button-width-200px {
            min-width: 160px !important;
          }
          &>>>.dropdown-menu {
            min-width: 160px !important;
          }
        }
      }
      .date-filter {
        @media screen and (min-width: 767px) {
          width: 27%;
        }
        @media screen and (max-width: 2000px) {
          margin-left: 3%;
        }
        @media screen and (max-width: 2300px) {
          margin-left: 3%;
        }
        @media screen and (min-width: 2500px) {
          /*margin-left: 0%;*/
        }
      }
    }
  }
  /* Helper css begins */
  .margin {
    &-0 {
      margin: 0;
    }
    &-bottom {
      &-0 {
        margin-bottom: 0;
      }
    }
  }
  .padding {
    &-0 {
      padding: 0;
    }
    &-top {
      &-0 {
        padding-top: 0;
      }
      &-bottom {
        &-5 {
          padding: 0 5px;
        }
      }
    }
    &-left {
      &-0 {
        padding-left: 0;
      }
    }
  }
  /* Helper css ends */
</style>



// WEBPACK FOOTER //
// src/pages/admin/BusinessReviews.vue